import { CustomPatientGroupsForm } from '../shared/form/CustomPatientGroupsForm';

export const CustomPatientGroupsCreateForm = CustomPatientGroupsForm;
